import { useLocation } from "react-router-dom";
import { cta, brand } from "@/content/site";
import { Link } from "react-router-dom";

// Persistent but unobtrusive mobile CTA. Hidden on the contact page so it
// never covers the form or footer content.
export default function StickyMobileCTA() {
  const location = useLocation();
  if (location.pathname === "/contact" || location.pathname === "/thank-you") {
    return null;
  }
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 p-3 bg-white/90 backdrop-blur-lg border-t border-border-neutral"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      <Link
        to={cta.primary.to}
        aria-label={cta.primary.label}
        className="flex items-center justify-center w-full rounded-full bg-lime text-forest font-bold py-3.5 text-sm shadow-[0_8px_24px_rgba(141,254,63,0.35)]"
      >
        {cta.primary.label}
      </Link>
    </div>
  );
}
